<template>
  <Loader :loader="loaderActive"/>
  <div class="container-fluid" style="background: #EEEEEE; padding-top: 4px;">
    <div class="row">
      <div class="category-head">
        <div class="back-link">
          <a @click="$router.back()">←</a>
        </div>
        <div class="category-title">
          <span class="topic-type">{{ topicType }}</span>
          <p>{{ categoryName }} </p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12 category-details">
        <div class="row">
          <div class="d-flex flex-column justify-content-center align-items-center">
            <img :src="topic.image_url" class="rounded-circle" width="70"
                 :alt="topic.name"/>
            <div class="topic-name"> {{ topic.name }} </div>
          </div>
        </div>

        <div class="row">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <argon-button fullWidth color="danger"
                          variant="gradient"
                          class="my-4 mb-1 me-2"
                          @click="startPlay"
                          style="background: #7F239F;" v-if="! topic.all_played">
              {{ $t('PLAY') }}
            </argon-button>
            <argon-button fullWidth color="danger"
                          variant="gradient"
                          class="my-4 mb-1 me-2"
                          style="background: #E7DAFB;" v-if="topic.all_played">
              {{ $t('ALREADY_PLAYED') }}
            </argon-button>
            <argon-button fullWidth color="dark"
                          variant="gradient"
                          class="my-4 mb-1"
                          v-if="! following"
                          @click="followChange" style="background: #7BDA5A">
              {{ $t('FOLLOW') }}
            </argon-button>
            <argon-button fullWidth color="dark"
                          variant="gradient"
                          class="my-4 mb-1"
                          v-if="following"
                          @click="followChange" style="background: #E5F8E1">
              {{ $t('FOLLOWING') }}
            </argon-button>
          </div>
        </div>
      </div>
    </div>

<!--    <div class="row level-content">-->
<!--      <div class="d-flex justify-content-between p-1">-->
<!--        <div class="level-line">-->
<!--          <div class="color-y-l"> {{ convertNumberToLangWise(level) }}</div>-->
<!--          <div class="level-title">{{ $t('YOUR_LEVEL') }} </div>-->
<!--        </div>-->
<!--        <div class="level-line">-->
<!--          <div class="color-f"> {{ convertNumberToLangWise(follower) }}</div>-->
<!--          <div class="level-title">{{ $t('FOLLOWER') }} </div>-->
<!--        </div>-->
<!--        <div class="">-->
<!--          <div class="color-l"> {{ convertNumberToLangWise(nextLevel) }}</div>-->
<!--          <div class="level-title">{{ $t('NEXT_LEVEL') }}</div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <RankingList :ranking-list="ranking" v-if="ranking.length" :tournament-id="topicId" :type="'topic'"/>
  </div>
</template>

<script>
import {sendRequest} from "@/http/axios.method";
import Loader from "@/views/components/Loader";
import {convertEnglishToMayanmar} from "@/helper/numberHelper";
import RankingList from "@/views/components/RankingList";
import ArgonButton from "@/components/ArgonButton";

export default {
  name: "TopicDetails",
  components: {
    Loader,
    RankingList,
    ArgonButton
  },
  data() {
    return {
      loaderActive: false,
      config: {
        'AUTHORIZATION': 'Bearer ' + this.$store.state.authUser.token
      },
      topicId: this.$route.query.topic_id,
      topic: [],
      ranking: [],
      topicType: this.$route.query.topic,
      categoryName: this.$route.query.category_name,
      following: false,
      level: 0,
      follower: 0,
      nextLevel: 0
    }
  },
  created() {
    this.getTopicDetails();
  },
  methods: {
    convertNumberToLangWise(data) {
      let numberDataWithLang = {
        'number': data,
        'lang': this.$store.getters.language
      };
      return convertEnglishToMayanmar(numberDataWithLang);
    },
    getTopicDetails() {
      this.loaderActive = true;
      sendRequest('post', 'v2.0/topic', {topic_id: this.topicId}, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              let topic_data = response.data;
              this.topic = topic_data.topic;
              this.level = topic_data.level;
              this.ranking = topic_data.ranking;
              this.following = topic_data.following;
              this.follower = this.topic.follower_count;
              this.nextLevel = topic_data.next_level;
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    followChange() {
      this.following = !this.following;
      let data = {
        topic_id: this.topicId,
        follow: this.following,
      }
      sendRequest('post', 'v2.0/follow-unfollow-topic', data, this.config)
          .then(() => {
            this.loaderActive = false;
            this.getTopicDetails();
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    startPlay() {
      this.$router.push({
        name: 'GamePlay',
        params: { id: this.topic.id },
        query: {topic: 'Top Topic', category_name: this.topic.category_name}
      });
    }
  }
}
</script>

<style scoped>

</style>
